export function applySuggestionToEditor(editor, suggestion, originalNodes) {
    console.log('applySuggestionToEditor called with:', {
        suggestion,
        editorSchemaMarks: Object.keys(editor.schema.marks),
        hasSuggestionAddMark: !!editor.schema.marks.suggestionAdd,
        hasSuggestionDeleteMark: !!editor.schema.marks.suggestionDelete,
    });
    editor
        .chain()
        .focus()
        .command(({ tr, state }) => {
        suggestion.operations.forEach((operation) => {
            console.log('Processing operation:', operation);
            switch (operation.kind) {
                case 'update': {
                    const originalNode = originalNodes.get(operation.nodeId);
                    const newNode = operation.node;
                    // Check if both nodes are text nodes with content
                    if (originalNode &&
                        newNode &&
                        'content' in originalNode &&
                        'content' in newNode &&
                        originalNode.kind === 'text' &&
                        newNode.kind === 'text') {
                        // Extract text from spans
                        const originalText = extractTextFromNode(originalNode);
                        const newText = extractTextFromNode(newNode);
                        // Find node position in document
                        let nodePos = null;
                        state.doc.descendants((node, pos) => {
                            if (node.attrs.id === operation.nodeId ||
                                node.attrs.blockId === operation.nodeId ||
                                node.attrs.tiptapNodeId === operation.nodeId) {
                                nodePos = pos;
                                return false;
                            }
                        });
                        if (nodePos !== null) {
                            const existingNode = state.doc.nodeAt(nodePos);
                            if (!existingNode)
                                return;
                            // Mark existing content as deleted
                            if (existingNode.content.size > 0 &&
                                state.schema.marks.suggestionDelete) {
                                tr.addMark(nodePos + 1, nodePos + existingNode.content.size + 1, state.schema.marks.suggestionDelete.create({
                                    suggestionId: operation.id,
                                }));
                            }
                            // Insert new content with add mark
                            if (state.schema.marks.suggestionAdd) {
                                const textNode = state.schema.text(newText);
                                const markedNode = textNode.mark([
                                    state.schema.marks.suggestionAdd.create({
                                        suggestionId: operation.id,
                                    }),
                                ]);
                                tr.insert(nodePos + existingNode.content.size + 1, markedNode);
                            }
                        }
                    }
                    break;
                }
                case 'delete': {
                    // Mark the node content as deleted
                    let nodePos = null;
                    state.doc.descendants((node, pos) => {
                        if (node.attrs.id === operation.nodeId ||
                            node.attrs.blockId === operation.nodeId ||
                            node.attrs.tiptapNodeId === operation.nodeId) {
                            nodePos = pos;
                            return false;
                        }
                    });
                    if (nodePos !== null) {
                        const node = state.doc.nodeAt(nodePos);
                        if (node &&
                            node.content.size > 0 &&
                            state.schema.marks.suggestionDelete) {
                            tr.addMark(nodePos + 1, nodePos + node.content.size + 1, state.schema.marks.suggestionDelete.create({
                                suggestionId: operation.id,
                            }));
                        }
                    }
                    break;
                }
                case 'insert': {
                    // Handle insertion based on position type
                    if (operation.position.kind === 'append') {
                        // console.log('Processing append operation');
                        // console.log(
                        //     'Available node types:',
                        //     Object.keys(state.schema.nodes)
                        // );
                        // Insert at the end of the document
                        const newNode = operation.node;
                        if (newNode.kind === 'text' && 'content' in newNode) {
                            const text = extractTextFromNode(newNode);
                            // console.log('Extracted text:', text);
                            if (state.schema.marks.suggestionAdd) {
                                // Check if this suggestion is already in the document
                                let alreadyExists = false;
                                state.doc.descendants((node, pos) => {
                                    if (node.marks.some((mark) => mark.type.name === 'suggestionAdd' &&
                                        mark.attrs.suggestionId ===
                                            operation.id)) {
                                        alreadyExists = true;
                                        return false;
                                    }
                                });
                                // console.log('Already exists check:', alreadyExists);
                                if (alreadyExists) {
                                    // console.warn(
                                    //     'Suggestion already exists in document, skipping'
                                    // );
                                    return;
                                }
                                // Create a new paragraph at the end
                                const textNode = state.schema.text(text);
                                const markedNode = textNode.mark([
                                    state.schema.marks.suggestionAdd.create({
                                        suggestionId: operation.id,
                                    }),
                                ]);
                                // Find the end of the document
                                const endPos = state.doc.content.size;
                                // console.log('Document end position:', endPos);
                                // console.log(
                                //     'Document content before insert:',
                                //     state.doc.toString()
                                // );
                                // Create a new text block node
                                const blockNode = state.schema.nodes.textBlock?.create({
                                    blockId: `suggestion-${operation.id}`,
                                }, markedNode);
                                if (blockNode) {
                                    // console.log(
                                    //     'Inserting textBlock node at position:',
                                    //     endPos
                                    // );
                                    // console.log('Block node:', blockNode.toString());
                                    tr.insert(endPos, blockNode);
                                    // console.log(
                                    //     'Document after insert:',
                                    //     tr.doc.toString()
                                    // );
                                }
                                else {
                                    // console.log(
                                    //     'Could not create textBlock node, trying paragraph'
                                    // );
                                    // Try with paragraph if textBlock doesn't exist
                                    const paragraphNode = state.schema.nodes.paragraph?.create({}, markedNode);
                                    if (paragraphNode) {
                                        // console.log(
                                        //     'Inserting paragraph node at position:',
                                        //     endPos
                                        // );
                                        tr.insert(endPos, paragraphNode);
                                        // console.log(
                                        //     'Document after insert:',
                                        //     tr.doc.toString()
                                        // );
                                    }
                                    else {
                                        // console.error(
                                        //     'Could not create any node type'
                                        // );
                                    }
                                }
                            }
                            else {
                                // console.error('suggestionAdd mark not found');
                            }
                        }
                    }
                    // TODO: Handle 'before' and 'after' position types
                    break;
                }
            }
        });
        return true;
    })
        .run();
}
function extractTextFromNode(node) {
    return node.content
        .map((span) => {
        if ('text' in span) {
            return span.text;
        }
        return '';
    })
        .join('');
}
function findNodeById(doc, id) {
    let foundPos = null;
    doc.descendants((node, pos) => {
        if (node.attrs.id === id ||
            node.attrs.blockId === id ||
            node.attrs.tiptapNodeId === id) {
            foundPos = pos;
            return false;
        }
    });
    return foundPos;
}
//# sourceMappingURL=applySuggestions.js.map